import React from "react";
import { Box, BoxProps } from "@mui/material";

interface ShimmerProps {
  width?: string | number;
  height?: string | number;
  sx?: BoxProps["sx"];
}

const Shimmer: React.FC<ShimmerProps> = ({
  width = "100%",
  height = "20px",
  sx,
}) => {
  return (
    <Box
      sx={{
        width,
        height,
        backgroundColor: "rgba(0, 0, 0, 0.11)",
        borderRadius: "4px",
        position: "relative",
        overflow: "hidden",
        "&::after": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent)",
          animation: "shimmer 1.5s infinite linear",
          transform: "translateX(-100%)",
        },
        "@keyframes shimmer": {
          "0%": {
            transform: "translateX(-100%)",
          },
          "100%": {
            transform: "translateX(100%)",
          },
        },
        ...sx,
      }}
    />
  );
};

export default Shimmer;
